import { render, staticRenderFns } from "./NovaIntegracao.vue?vue&type=template&id=6f992780&"
import script from "./NovaIntegracao.vue?vue&type=script&lang=js&"
export * from "./NovaIntegracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports